var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#FCC003"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 120,
    height: 120,
    rx: 60,
    stroke: "#F9E3B6",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2834 64.8143C71.0897 64.8143 77.4179 58.4861 77.4179 50.6798C77.4179 42.8735 71.0897 36.5453 63.2834 36.5453C55.4771 36.5453 49.1489 42.8735 49.1489 50.6798C49.1489 58.4861 55.4771 64.8143 63.2834 64.8143Z",
    stroke: "white",
    strokeWidth: 4.24035,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93.0829C39 82.1428 49.8835 73.2946 63.283 73.2946C65.9969 73.2946 68.6259 73.6621 71.0853 74.3406",
    stroke: "white",
    strokeWidth: 4.24035,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3417 84.1468C96.3417 87.539 94.8435 90.5638 92.4972 92.6274C90.4901 94.3801 87.8893 95.4543 85.0341 95.4543C78.7867 95.4543 73.7266 90.3942 73.7266 84.1468C73.7266 80.5849 75.3662 77.3905 77.9669 75.3269C79.9175 73.7721 82.3769 72.8392 85.0341 72.8392C91.2816 72.8392 96.3417 77.8993 96.3417 84.1468Z",
    stroke: "white",
    strokeWidth: 3.83149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7411 80.6128V84.8531L82.2075 86.9733",
    stroke: "white",
    strokeWidth: 3.83149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTick);
export default __webpack_public_path__ + "static/media/user-tick.eef70e4cd2a64f0aab102231b6ff79ca.svg";
export { ForwardRef as ReactComponent };